import { Flex, MarkdownEditor, Hint } from "/app/src/component";
import React from "react";

const MessageContainerHeaderStyle = {
  dataName: "MessageContainerHeader",
  color: "black",
  fontSize: "24px",
  fontWeight: "300",
  w: "70%",
  hAlignContent: "center",
  marginBottom: "15px",
};

const OfflineMessageContainerStyle = {
  dataName: "OfflineMessageContainer",
  width: "100%",
  mb: "20px",
  mt: "30px",
  shrink: 0,
  color: "black",
  column: true,
  hAlignContent: "center",
};

const MessageContainerBodyStyle = {
  dataName: "MessageContainerBody",
  w: "70%",
  fontSize: "16px",
  color: "black1",
  fontWeight: "400",
  hAlignContent: "center",
};

const LabelHintProps = {
  style: { marginLeft: "4px" },
  position: "right",
  tooltip:
    "Skräddarsy ert offlinemeddelande med exempelvis öppettider. Offlinemeddelande prioriteras alltid framför eventuella automeddelanden. ",
};

const SmallContainerStyle = {
  maxWidth: "456px",
  width: "100%",
  grow: 1,
};

export default ({ offlineMessage, setOfflineMessage }) => {
  const onContentChange = (markdownText) => {
    setOfflineMessage(markdownText);
  };

  offlineMessage = offlineMessage
    ? offlineMessage
    : "Vi är för närvarande offline, men lämna gärna ett meddelande!";
  return (
    <Flex {...OfflineMessageContainerStyle}>
      <Flex {...MessageContainerHeaderStyle}>
        <Flex {...SmallContainerStyle}>
          Offlinemeddelande <Hint {...LabelHintProps} />
        </Flex>
      </Flex>
      <Flex {...MessageContainerBodyStyle}>
        <Flex {...SmallContainerStyle}>
          <MarkdownEditor
            height="105px"
            text={offlineMessage}
            onTextChange={onContentChange}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/OfflineSettings/_OfflineMessage.js